import * as Yup from 'yup'
import { useMutation } from '@apollo/client'
import { useFormik } from 'formik'
import { ResetPassword as ResetPasswordType, ResetPasswordVariables } from '../../types'
import { RESET_PASSWORD } from './operations'

const validationSchema = Yup.object({
  newPassword: Yup.string().required('This field is required'),
  newPasswordConfirmation: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords do not match')
    .required('This field is required'),
})

interface Props {
  onCompleted?: () => void
  onError?: () => void
  token: string
}

export const useResetPassword = ({ onCompleted, onError, token }: Props) => {
  const [resetPassword, { loading }] = useMutation<ResetPasswordType, ResetPasswordVariables>(
    RESET_PASSWORD
  )
  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: {
      newPassword: '',
      newPasswordConfirmation: '',
    },
    validationSchema,
    async onSubmit() {
      try {
        await resetPassword({
          variables: {
            inputData: {
              token,
              newPassword: values.newPassword,
            },
          },
        })
        if (onCompleted) {
          onCompleted()
        }
      } catch {
        if (onError) {
          onError()
        }
      }
    },
  })

  return {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isResetPasswordLoading: loading,
  }
}
